/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ConnectProviderResponse, ConnectProviderVars } from '../openapi-types.gen.js';

export type { ConnectProviderResponse, ConnectProviderVars } from '../openapi-types.gen.js';

export const useConnectProvider = createMutationHook<ConnectProviderVars, ConnectProviderResponse, unknown>({
  specName: 'useConnectProvider',
  path: '/v1/auth/connect-provider',
  method: 'POST',
  resolveUrl: (vars: ConnectProviderVars) => `/v1/auth/connect-provider`,
  buildBody: (vars: ConnectProviderVars) => ({ oidcToken: vars.oidcToken, oauthPublicKey: vars.oauthPublicKey, provider: vars.provider, providerUserId: vars.providerUserId, oauthProfile: vars.oauthProfile, importProfile: vars.importProfile }),
  parseResponse: (raw: unknown): ConnectProviderResponse => raw as ConnectProviderResponse,
  optimistic: [{
    queryKey: ['auth', 'detail'],
    apply: (prev: any, vars: ConnectProviderVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
